import classNames from "classnames";
import React, { forwardRef, PropsWithChildren } from "react";

import { ISectionProps, Section } from "@/eworkitComponents";

interface Props extends ISectionProps {}

/**
 * @deprecated Use iris-based implementation instead.
 */
export const Container = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => {
  const { className, padding = ["md"], ...restSectionProps } = props;
  const classes = classNames("container", className);

  return <Section ref={ref} className={classes} padding={padding} {...restSectionProps} />;
});
